// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equation-builder-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
}

.top {
  display: flex;
  flex: 0 0 auto;
  min-height: 0;
  height: auto;
  max-height: 190px;
  justify-content: space-between;
  align-items: flex-start;
}

.bottom {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
.bottom #functions {
  display: grid;
  grid-template-rows: auto 1fr 80px;
  grid-gap: 8px;
  height: 100%;
  min-height: 0;
}
.bottom #functions #function-details {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
}
.bottom #functions #function-syntax {
  resize: none;
  cursor: text !important;
}
.bottom #identifiers {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 8px;
  height: 100%;
  min-height: 0;
  align-self: stretch;
}
.bottom #identifiers #identifier-details {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
}

.ace-editor-wrapper {
  flex: 1 1 auto;
  min-width: 320px;
  max-width: none;
  margin-right: 24px;
  margin-left: 0 !important;
  padding-left: 0 !important;
  display: flex;
  flex-direction: column;
}

ace, #editor, ace-editor {
  width: 100%;
  min-height: 180px;
  max-height: 220px;
  height: 180px !important;
  border: 1px solid #dfe0e1;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  padding: 8px 8px 8px 0px;
  margin-left: 0 !important;
}

#key-pad {
  flex: 0 0 260px;
  min-width: 180px;
  margin-left: 0;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
}

.action-buttons {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.action-buttons #validation-message {
  display: flex;
  align-items: center;
  line-height: 26px;
  padding: 0;
  flex: 1;
}
.action-buttons #validation-message #button-undo {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  text-align: center;
  margin: 0;
  font-size: 10px;
  padding: 0;
}
.action-buttons #validation-message .show-undo {
  animation: fadein 1.5s;
  display: block;
}
.action-buttons #validation-message .disabled {
  animation: fadeout 0.5s;
}
.action-buttons #validation-message .valid-equation {
  animation: fadein 1.5s;
  color: #72bf44;
}
.action-buttons #validation-message .invalid-equation, .action-buttons #validation-message .invalid-equation-link {
  animation: fadein 1.5s;
  color: #f07d23;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.action-buttons #validation-message .invalid-equation-link {
  text-decoration: underline;
  cursor: pointer;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.action-buttons button {
  min-width: 80px;
}

#debug {
  word-wrap: break-word;
  overflow: hidden;
  padding: 1em;
  background-color: ivory;
  border: solid 1px olive;
  overflow-y: scroll;
}

#clear-editor-button {
  border-radius: 50%;
  border: none;
  bottom: calc(100% - 180px);
  cursor: pointer;
  height: 24px;
  opacity: 0.35 !important;
  position: absolute;
  right: 300px;
  width: 24px;
}
#clear-editor-button:hover {
  opacity: 0.5 !important;
}

#switch-theme {
  display: none; /* Hidden for now, but keeping functionality for future use */
  background-color: #f5f5f5;
  color: #222;
  border-radius: 4px;
  border: 1px solid #dfe0e1;
  min-width: 36px;
  padding: 2px 8px;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  opacity: 1 !important;
  transition: background 0.2s, color 0.2s;
  position: relative;
  z-index: 2;
}

body.dark-theme #switch-theme,
#switch-theme.dark {
  background-color: #222;
  color: #fff;
  border: 1px solid #444;
}

#switch-theme:hover {
  background-color: #e0e0e0;
  color: #111;
}

body.dark-theme #switch-theme:hover,
#switch-theme.dark:hover {
  background-color: #444;
  color: #fff;
}

.group-dropdown, .bottom #functions #function-groups, .bottom #functions #function-details, .bottom #functions #function-syntax, .bottom #identifiers #identifier-groups, .bottom #identifiers #identifier-details {
  -webkit-tap-highlight-color: transparent;
  background-clip: padding-box;
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid #dfe0e1;
  box-sizing: border-box;
  color: #505050;
  cursor: pointer;
  display: inline-block;
  font-family: Helvetica, sans-serif !important;
  font-size: 0.76rem;
  font-weight: 600;
  line-height: 20px;
  margin: 0px;
  min-width: 100px;
  overflow-y: auto;
  padding: 4px 9px;
  position: relative;
  text-align: left;
  transition: all 0.3s ease;
  width: auto;
}

#key-pad {
  -webkit-user-select: none;
          user-select: none;
  display: grid;
  padding: 10px;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
}
#key-pad #left-keys,
#key-pad #right-keys {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-gap: 5px;
}
#key-pad #left-keys div,
#key-pad #right-keys div {
  background-color: #a1dbff;
  background: linear-gradient(to bottom, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);
  border-radius: 4px;
  border: solid 2px #a1dbff;
  color: #505050;
  cursor: pointer;
  font-family: monospace;
  font-size: 1.1em;
  line-height: 32px;
  max-height: 32px;
  overflow: hidden;
  text-align: center;
}
#key-pad #left-keys div:hover,
#key-pad #right-keys div:hover {
  transform: scale(1.01);
  font-weight: bold;
}
#key-pad #left-keys #kp-0 {
  grid-column-start: 1;
  grid-column-end: 3;
}
#key-pad #right-keys .kp-empty {
  visibility: hidden;
}

.marked {
  background-color: lightsalmon;
}

kendo-window {
  border-radius: 4px !important;
}

:host ::ng-deep kendo-window-titlebar,
:host ::ng-deep .k-dialog-titlebar,
:host ::ng-deep .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-data/equations/equation-builder/equation-builder.component.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AAFF;AAIE;EACE,aAAA;EACA,iCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AAFJ;AAQI;EAEE,YAAA;EACA,aAAA;EACA,cAAA;AAPN;AAUI;EACE,YAAA;EAEA,uBAAA;AATN;AAaE;EACE,aAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAXJ;AAiBI;EAEE,YAAA;EACA,aAAA;EACA,cAAA;AAhBN;;AAqBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAlBF;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,OAAA;AAlBJ;AAoBI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAlBN;AAqBI;EACE,sBAAA;EACA,cAAA;AAnBN;AAsBI;EACE,uBAAA;AApBN;AAwBI;EACE,sBAAA;EACA,cAhJE;AA0HR;AAwBI;EACE,sBAAA;EACA,cAnJG;EAoJH,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtBN;AAwBI;EAEE,0BAAA;EACA,eAAA;AAvBN;AA0BI;EACE;IACE,UAAA;EAxBN;EA0BI;IACE,UAAA;EAxBN;AACF;AA0BI;EACE;IACE,UAAA;EAxBN;EA0BI;IACE,UAAA;EAxBN;AACF;AA4BE;EACE,eAAA;AA1BJ;;AA8BA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA3BF;AA4BE;EACE,uBAAA;AA1BJ;;AA8BA;EACE,aAAA,EAAA,6DAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;AA3BF;;AA8BA;;EAEE,sBAAA;EACA,WAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,WAAA;AA3BF;;AA8BA;;EAEE,sBAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,wCAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AA3BF;;AA+BA;EACE,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AA5BF;AA8BE;;EAEE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,aAAA;AA5BJ;AA8BI;;EACE,yBAAA;EACA,6EAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA3BN;AA6BM;;EACE,sBAAA;EACA,iBAAA;AA1BR;AA+BI;EACE,oBAAA;EACA,kBAAA;AA7BN;AAiCI;EACE,kBAAA;AA/BN;;AAoCA;EACE,6BAAA;AAjCF;;AAoCA;EACE,6BAAA;AAjCF;;AAoCA;;;EAGE,oCAAA;EACA,kCAAA;AAjCF","sourcesContent":["$green: #72bf44;\r\n$orange: #f07d23;\r\n\r\n.equation-builder-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.top {\r\n  display: flex;\r\n  flex: 0 0 auto;\r\n  min-height: 0;\r\n  height: auto;\r\n  max-height: 190px;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.bottom {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-gap: 16px;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  height: 100%;\r\n\r\n  #functions {\r\n    display: grid;\r\n    grid-template-rows: auto 1fr 80px;\r\n    grid-gap: 8px;\r\n    height: 100%;\r\n    min-height: 0;\r\n\r\n    #function-groups {\r\n      @extend .group-dropdown;\r\n    }\r\n\r\n    #function-details {\r\n      @extend .group-dropdown;\r\n      height: 100%;\r\n      min-height: 0;\r\n      flex: 1 1 auto;\r\n    }\r\n\r\n    #function-syntax {\r\n      resize: none;\r\n      @extend .group-dropdown;\r\n      cursor: text !important;\r\n    }\r\n  }\r\n\r\n  #identifiers {\r\n    display: grid;\r\n    grid-template-rows: auto 1fr;\r\n    grid-gap: 8px;\r\n    height: 100%;\r\n    min-height: 0;\r\n    align-self: stretch;\r\n\r\n    #identifier-groups {\r\n      @extend .group-dropdown;\r\n    }\r\n\r\n    #identifier-details {\r\n      @extend .group-dropdown;\r\n      height: 100%;\r\n      min-height: 0;\r\n      flex: 1 1 auto;\r\n    }\r\n  }\r\n}\r\n\r\n.ace-editor-wrapper {\r\n  flex: 1 1 auto;\r\n  min-width: 320px;\r\n  max-width: none;\r\n  margin-right: 24px;\r\n  margin-left: 0 !important;\r\n  padding-left: 0 !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nace, #editor, ace-editor {\r\n  width: 100%;\r\n  min-height: 180px;\r\n  max-height: 220px;\r\n  height: 180px !important;\r\n  border: 1px solid #dfe0e1;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  padding: 8px 8px 8px 0px;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n#key-pad {\r\n  flex: 0 0 260px;\r\n  min-width: 180px;\r\n  margin-left: 0;\r\n  align-self: flex-start;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.action-buttons {\r\n  margin-top: 24px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n\r\n  #validation-message {\r\n    display: flex;\r\n    align-items: center;\r\n    line-height: 26px;\r\n    padding: 0;\r\n    flex: 1;\r\n\r\n    #button-undo {\r\n      height: 34px;\r\n      width: 34px;\r\n      border-radius: 50%;\r\n      text-align: center;\r\n      margin: 0;\r\n      font-size: 10px;\r\n      padding: 0;\r\n    }\r\n\r\n    .show-undo {\r\n      animation: fadein 1.5s;\r\n      display: block;\r\n    }\r\n\r\n    .disabled {\r\n      animation: fadeout 0.5s;\r\n      // display: none;\r\n    }\r\n\r\n    .valid-equation {\r\n      animation: fadein 1.5s;\r\n      color: $green;\r\n    }\r\n    .invalid-equation {\r\n      animation: fadein 1.5s;\r\n      color: $orange;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n    }\r\n    .invalid-equation-link {\r\n      @extend .invalid-equation;\r\n      text-decoration: underline;\r\n      cursor: pointer;\r\n    }\r\n\r\n    @keyframes fadein {\r\n      from {\r\n        opacity: 0;\r\n      }\r\n      to {\r\n        opacity: 1;\r\n      }\r\n    }\r\n    @keyframes fadeout {\r\n      from {\r\n        opacity: 1;\r\n      }\r\n      to {\r\n        opacity: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  button {\r\n    min-width: 80px;\r\n  }\r\n}\r\n\r\n#debug {\r\n  word-wrap: break-word;\r\n  overflow: hidden;\r\n  padding: 1em;\r\n  background-color: ivory;\r\n  border: solid 1px olive;\r\n  overflow-y: scroll;\r\n}\r\n\r\n#clear-editor-button {\r\n  border-radius: 50%;\r\n  border: none;\r\n  bottom: calc(100% - 180px);\r\n  cursor: pointer;\r\n  height: 24px;\r\n  opacity: 0.35 !important;\r\n  position: absolute;\r\n  right: 300px;\r\n  width: 24px;\r\n  &:hover {\r\n    opacity: 0.5 !important;\r\n  }\r\n}\r\n\r\n#switch-theme {\r\n  display: none; /* Hidden for now, but keeping functionality for future use */\r\n  background-color: #f5f5f5;\r\n  color: #222;\r\n  border-radius: 4px;\r\n  border: 1px solid #dfe0e1;\r\n  min-width: 36px;\r\n  padding: 2px 8px;\r\n  margin-bottom: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  opacity: 1 !important;\r\n  transition: background 0.2s, color 0.2s;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\nbody.dark-theme #switch-theme,\r\n#switch-theme.dark {\r\n  background-color: #222;\r\n  color: #fff;\r\n  border: 1px solid #444;\r\n}\r\n\r\n#switch-theme:hover {\r\n  background-color: #e0e0e0;\r\n  color: #111;\r\n}\r\n\r\nbody.dark-theme #switch-theme:hover,\r\n#switch-theme.dark:hover {\r\n  background-color: #444;\r\n  color: #fff;\r\n}\r\n\r\n.group-dropdown {\r\n  -webkit-tap-highlight-color: transparent;\r\n  background-clip: padding-box;\r\n  background-color: transparent;\r\n  border-radius: 3px;\r\n  border: 1px solid #dfe0e1;\r\n  box-sizing: border-box;\r\n  color: #505050;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-family: Helvetica, sans-serif !important;\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n  line-height: 20px;\r\n  margin: 0px;\r\n  min-width: 100px;\r\n  overflow-y: auto;\r\n  padding: 4px 9px;\r\n  position: relative;\r\n  text-align: left;\r\n  transition: all 0.3s ease;\r\n  width: auto;\r\n}\r\n\r\n// CALCULATOR\r\n#key-pad {\r\n  user-select: none;\r\n  display: grid;\r\n  padding: 10px;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-gap: 16px;\r\n\r\n  #left-keys,\r\n  #right-keys {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-template-rows: repeat(4, 1fr);\r\n    grid-gap: 5px;\r\n\r\n    div {\r\n      background-color: #a1dbff;\r\n      background: linear-gradient(to bottom, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);\r\n      border-radius: 4px;\r\n      border: solid 2px #a1dbff;\r\n      color: #505050;\r\n      cursor: pointer;\r\n      font-family: monospace;\r\n      font-size: 1.1em;\r\n      line-height: 32px;\r\n      max-height: 32px;\r\n      overflow: hidden;\r\n      text-align: center;\r\n\r\n      &:hover {\r\n        transform: scale(1.01);\r\n        font-weight: bold;\r\n      }\r\n    }\r\n  }\r\n  #left-keys {\r\n    #kp-0 {\r\n      grid-column-start: 1;\r\n      grid-column-end: 3;\r\n    }\r\n  }\r\n  #right-keys {\r\n    .kp-empty {\r\n      visibility: hidden;\r\n    }\r\n  }\r\n}\r\n\r\n.marked {\r\n  background-color: lightsalmon;\r\n}\r\n\r\nkendo-window {\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep kendo-window-titlebar,\r\n:host ::ng-deep .k-dialog-titlebar,\r\n:host ::ng-deep .k-window-titlebar {\r\n  background-color: #51738b !important;\r\n  padding: 0.25rem 0.5rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
